<template>
  <div class="card empty-state-card">
    <div class="empty-state-icon" aria-hidden="true">
      <i :class="icon"></i>
    </div>
    <div class="empty-state-copy">
      <p v-if="eyebrow" class="eyebrow">{{ eyebrow }}</p>
      <h3>{{ title }}</h3>
      <p>{{ message }}</p>
      <div v-if="actions.length" class="empty-state-actions">
        <RouterLink
          v-for="action in actions"
          :key="`${action.to}-${action.label}`"
          :class="action.variant === 'secondary' ? 'btn-outline' : 'btn'"
          :to="action.to"
        >
          <i v-if="action.icon" :class="action.icon"></i>
          {{ action.label }}
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppEmptyState',
  props: {
    eyebrow: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: 'fa-solid fa-box-open',
    },
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    actions: {
      type: Array,
      default() {
        return []
      },
    },
  },
}
</script>
